import { selfAxios } from "../../../../axios/selfAxios.js";
async function opPostQueryProductionOrderBaseAttrList(params) {
  const res = await selfAxios.post(`/designordercenter/linkage/queryProductionOrderBaseAttrList`, params);
  return res.data;
}
export { opPostQueryProductionOrderBaseAttrList };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designordercenter/linkage/queryProductionOrderBaseAttrList/post.js